// extracted by mini-css-extract-plugin
export var whatsapp = "WhatsAppLink-module--whatsapp--9dee2";